import Vue from 'vue';

import di from 'di';
import { Session } from 'js-core/js/plugins/Authentication';
import createQuery from 'js-core/js/apollo/queries/createQuery';

import InitQuery from 'gql/queries/Init.gql';

export default class EmailAccountType {
    static NAME = 'email';

    async login(credentials) {

        const basic = btoa(`${credentials.username}:${credentials.password}`);

        const response = await Vue.http.post('access_token', null, {

            headers: {
                Authorization: `Basic ${basic}`
            }
        });

        const data = response.data.data;
        if(!data) {
            throw 'Invalid login response';
        }

        const apollo = di.get('apollo');
        const initResult = await apollo.query(createQuery(InitQuery, {

            fetchPolicy: 'network-only',

            context: {
                headers: {
                    Authorization: `Bearer ${data.token}`
                }
            }
        }));

        if(!initResult || !initResult.data || !initResult.data.identityUser) {
            throw 'Invalid init response';
        }

        const user = initResult.data.identityUser;

        // if (user.role === UserRole.USER) {
        //     throw 'Role not sufficient';
        // }

        return new Session(EmailAccountType.NAME, user, new Date().getTime(), data.expires, data.token);
    }

    authenticate(identity) {

        return Promise.resolve();
    }

    logout(session) {

        return Promise.resolve();
    }
}
